         // API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {

});

export function emailLinkText_click(event) {
    //'Email' is the name of the lightbox to be popped 
    // The second parameter should match the Title row in the Points of Contact table e.g. 'Website Committee'
    wixWindow.openLightbox('Email', 'Legal');
}